import { OddsMarketTypes } from '../types';

export const MARKETS_WITH_ARBITRARY_SELECTIONS = [
  'CORRECT_SCORE',
  'FIRST_HALF_AND_FINAL_RESULT',
  'FIRST_PLAYER_TO_SCORE',
  'PLAYER_TO_SCORE_DURING_GAME',
  'FIRST_HALF_GOALS',
  'PLAYER_TO_RECEIVE_CARD',
];

export const SUPPORTED_MARKETS = [
  '12',
  '1X2',
  'OVER_UNDER',
  'DOUBLE_CHANCE',
  'BOTH_TO_SCORE',
  'DRAW_NO_BET',
  'FIRST_TEAM_TO_SCORE',
  // 'GAME_HANDICAP', // Not supported
  'FIRST_HALF',
  'SECOND_HALF',
  'FULL_TIME',
  ...MARKETS_WITH_ARBITRARY_SELECTIONS,
];

export const MARKETS_WITH_VALUES = [OddsMarketTypes.OVER_UNDER, OddsMarketTypes.GAME_HANDICAP, OddsMarketTypes.FIRST_HALF_GOALS];
